import { CATEGORIES } from '@/constants/static-data/categories';
import { CATEGORY_TYPES } from '@/constants/static-data/category-types';
import { TEMPLATE_DIFFICULTY_LEVELS } from '@/utilities/consts';

const getCategoryGroup = state => {
  const category = CATEGORIES.filter(c => c.slug === state?.categoryFilters?.slug)[0];
  return CATEGORY_TYPES.filter(ct => ct.id === category?.category_type_id)[0]?.name;
};

const getSearchTerms = state => state?.searchTags.join(', ');

const getSubcategories = state => {
  const subcategories = Object.entries(state?.categoryFilters?.subCategories)?.filter(
    sc => sc[1].selected,
  );
  return subcategories.map(sc => sc[1].name).join(', ');
};

const getContentIdFilter = state => {
  const rightsManager = state?.categoryFilters?.rightsManager;
  if (rightsManager === 1) {
    return 'Only';
  }
  if (rightsManager === -1) {
    return 'Exclude';
  }
  return null;
};

const getResolution = state => {
  const resolution = state?.categoryFilters?.resolution?.name;
  if (resolution === 'All Resolutions') {
    return null;
  }
  return resolution;
};

const getOrientation = state => {
  const orientation = state?.categoryFilters?.orientation?.name;
  if (orientation === 'All Orientations') {
    return null;
  }
  return orientation;
};

const getVersion = state => {
  const version = state?.categoryFilters?.version?.name;
  if (version === 'All Versions') {
    return null;
  }
  return version;
};

const getUsageRights = state => {
  const editorial = state?.categoryFilters?.editorial?.slug;
  if (typeof editorial === 'undefined' || editorial === 'all-editorials') {
    return null;
  }
  return editorial[0].toUpperCase() + editorial.slice(1);
};

const getFps = state => {
  const fps = state?.categoryFilters?.fps?.name;
  if (fps === 'All FPSs') {
    return null;
  }
  return fps;
};

const getTemplateDifficultyLevel = state => {
  return state?.categoryFilters?.templateDifficultyLevel === TEMPLATE_DIFFICULTY_LEVELS.SIMPLE
    ? 'easy'
    : state?.categoryFilters?.templateDifficultyLevel;
};

const getBpm = state => state?.categoryFilters?.bpms.join(', ');

const getFreeAssetsFilter = state => !!state?.isFree;

const getIsFilterApplied = state => {
  if (getSearchTerms(state) !== '') {
    return true;
  }
  if (getSubcategories(state) !== '') {
    return true;
  }
  if (getResolution(state) !== null) {
    return true;
  }
  if (getOrientation(state) !== null) {
    return true;
  }
  if (getVersion(state) !== null) {
    return true;
  }
  if (getUsageRights(state) !== null) {
    return true;
  }
  if (getFps(state) !== null) {
    return true;
  }
  if (getContentIdFilter(state) !== null) {
    return true;
  }
  if (getBpm(state) !== '') {
    return true;
  }
  if (getFreeAssetsFilter(state) === true) {
    return true;
  }
  if (state?.dateAdded !== 'any-time') {
    return true;
  }

  if (getTemplateDifficultyLevel(state)) {
    return true;
  }

  return false;
};

export const stateToBrowseEventProperties = state => ({
  trigger: state?.searchEventTriggerSource || 'category browsing',
  location: state?.searchEventLocationSource,

  category: getCategoryGroup(state),

  sort_by: state?.sortBy?.replace(/-/g, ' '),
  date_added: state?.dateAdded?.replace(/-/g, ' '),

  search_term: getSearchTerms(state),
  filters: getSubcategories(state),
  resolution: getResolution(state),
  orientation: getOrientation(state),
  version: getVersion(state),
  usage_rights: getUsageRights(state),
  FPSs: getFps(state),
  content_ID_filter: getContentIdFilter(state),
  bpm: getBpm(state),
  free_assets_filter: getFreeAssetsFilter(state),

  is_filter_applied: getIsFilterApplied(state),

  complexity_level_filter: getTemplateDifficultyLevel(state),
});
